import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useChangeProjectManagementBulkDialogContent } from "@components/table/projects/bulk-actions/bulk-change-project-management-helper";
import { GroupAndProjectManagerSelection } from "@pages/project-details/project-overview/change-management/group-and-project-manager-selection";
import { updateProjectDetails } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedEntitiesSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { setBulkActionName } from "@store/table/table-slice";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useState } from "react";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { useResolveProjectManagerIdentity } from "@hooks/projects/use-resolve-project-manager-identity";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { Text, ManagementIcon } from "@flat-ui";

/** Button allowing to change management of project in company */
export function BulkChangeProjectManagement(t0) {
  const $ = _c(43);
  const {
    companyId
  } = t0;
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [payload, setPayload] = useState(t1);
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [selectedProjectManager, setSelectedProjectManager] = useState(null);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const dispatch = useAppDispatch();
  const {
    resolveProjectManagerIdentity
  } = useResolveProjectManagerIdentity();
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("projects");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedEntities = useAppSelector(t2);
  const {
    bulkDialogContent,
    successDialogContent
  } = useChangeProjectManagementBulkDialogContent();
  const mode = useBulkActionsMode();
  let t3;
  let t4;
  if ($[2] !== shouldShowSuccessDialog) {
    t3 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t4 = [shouldShowSuccessDialog];
    $[2] = shouldShowSuccessDialog;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== companyId || $[6] !== resolveProjectManagerIdentity || $[7] !== selectedGroupId || $[8] !== selectedProjectManager) {
    t5 = () => {
      if (!companyId) {
        throw new Error("Company id is required!");
      }
      const projectManagerIdentity = resolveProjectManagerIdentity(selectedProjectManager);
      if (typeof selectedGroupId === "undefined" || !projectManagerIdentity) {
        setPayload({});
        return;
      }
      setPayload({
        projectManagerIdentity,
        groupId: String(selectedGroupId)
      });
    };
    t6 = [companyId, selectedGroupId, selectedProjectManager, resolveProjectManagerIdentity];
    $[5] = companyId;
    $[6] = resolveProjectManagerIdentity;
    $[7] = selectedGroupId;
    $[8] = selectedProjectManager;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== dispatch) {
    t7 = function onNewGroupClicked() {
      dispatch(setBulkActionName("changeProjectManagement"));
      setShouldShowDialog(true);
    };
    $[11] = dispatch;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const onNewGroupClicked = t7;
  let t8;
  if ($[13] !== mode) {
    t8 = getBulkActionButtonConfig(mode, "Project management");
    $[13] = mode;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const config = t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ManagementIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== config.shouldShowText) {
    t10 = config.shouldShowText && <Text variant="buttonM">Management</Text>;
    $[16] = config.shouldShowText;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== config.loadingTrackColor || $[19] !== config.rippleColor || $[20] !== config.sx || $[21] !== config.tooltipText || $[22] !== onNewGroupClicked || $[23] !== t10) {
    t11 = <FaroTextButton onClick={onNewGroupClicked} tooltipText={config.tooltipText} loadingTrackColor={config.loadingTrackColor} startIcon={t9} rippleColor={config.rippleColor} sx={config.sx}>{t10}</FaroTextButton>;
    $[18] = config.loadingTrackColor;
    $[19] = config.rippleColor;
    $[20] = config.sx;
    $[21] = config.tooltipText;
    $[22] = onNewGroupClicked;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== bulkActionName || $[26] !== shouldShowSuccessDialog || $[27] !== successDialogContent) {
    t12 = bulkActionName === "changeProjectManagement" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[25] = bulkActionName;
    $[26] = shouldShowSuccessDialog;
    $[27] = successDialogContent;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== bulkActionName || $[30] !== bulkDialogContent || $[31] !== companyId || $[32] !== dispatch || $[33] !== payload || $[34] !== selectedEntities || $[35] !== selectedGroupId || $[36] !== selectedProjectManager || $[37] !== shouldShowDialog) {
    t13 = bulkActionName === "changeProjectManagement" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkChangeGroup} bulkActionCallback={project => dispatch(updateProjectDetails({
      projectId: project.id,
      payload
    })).unwrap()} shouldDisableConfirmButton={Object.keys(payload).length === 0} selectedEntities={selectedEntities} uniqueIdKey="id" tableDataType="projects"><GroupAndProjectManagerSelection selectedGroupId={selectedGroupId} setSelectedGroupId={setSelectedGroupId} setSelectedProjectManager={setSelectedProjectManager} selectedProjectManager={selectedProjectManager} companyId={companyId} /></FaroBulkDialog>;
    $[29] = bulkActionName;
    $[30] = bulkDialogContent;
    $[31] = companyId;
    $[32] = dispatch;
    $[33] = payload;
    $[34] = selectedEntities;
    $[35] = selectedGroupId;
    $[36] = selectedProjectManager;
    $[37] = shouldShowDialog;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t11 || $[40] !== t12 || $[41] !== t13) {
    t14 = <>{t11}{t12}{t13}</>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}